/**
 * Who may create a sales order by hand (purchase tour bug 5a, 2026-10-07).
 *
 * Mirrors backend POST /orders/so requireRole('ADMIN','OWNER','PURCHASE',
 * 'purchase_head') plus the super-role bypass, and purchase_manager through the
 * role alias (lib/roleAliases.ts). 2026-07-07 F2: manual SO create is a
 * purchase/admin tool; sales raise an enquiry instead.
 */
import { roleInList } from './roleAliases';

const SO_CREATE_ROLES: readonly string[] = ['admin', 'owner', 'super_admin', 'purchase', 'purchase_head'];

export function canCreateSalesOrder(roleName: string | null | undefined): boolean {
  return roleInList(roleName, SO_CREATE_ROLES);
}
